import axios from "axios";
import store from "./store/index";
import Vue from "vue";
export const isTest = false;
export const URL = isTest ? "http://localhost:8443" : "https://s2.seniorapp.pl";

// https://s2.seniorapp.pl
// https://s3.seniorapp.pl
// http://localhost:8443
// http://77.55.214.241:9091

const instance = axios.create({
  baseURL: URL,
});

const requestsWithoutLoaderIcon = [
  "/api/profile/needVerification",
  "/api/chat/unreadChatsNumber",
  "/api/adminTask/todo/amount",
  "/api/withdraw/waitingPaymentsNumber",
  "/api/profile/triedToLogInNumber",
];
let requestCounter = 0;
const decrementLoader = () => {
  requestCounter--;
  if (requestCounter === 0) {
    if (document.getElementsByClassName("loader")[0]) {
      document
        .getElementsByClassName("loader")[0]
        .classList.remove("visibleLoader");
    }
  }
};
instance.interceptors.request.use(
  // Return a successful response back to the calling service
  (request) => {
    let errorInRequest = null;
    try {
      if (request.data && request.data.entries()) {
        for (const pair of request.data.entries()) {
          if (pair[1] && pair[1].size && pair[1].size > 10000000) {
            Vue.notify({
              group: "error",
              text:
                "Rozmiar pliku jest za duży. Maksymalny rozmiar pliku to 10MB",
            });
            return;
          }
        }
      }
    } catch (error) {
      errorInRequest = error;
      request.errorInRequest = errorInRequest;
    }

    if (
      request.url.includes("/api/chat/messages") ||
      request.url.includes("/api/chat/unreadChatsNumber") ||
      request.url.includes("/api/profile/needVerification") ||
      request.url.includes("/api/adminTask/todo/amount") ||
      request.url.includes("/api/withdraw/waitingPaymentsNumber") ||
      request.url.includes("/api/profile/triedToLogInNumber")
    ) {
      request.headers.common[
        "Authorization"
      ] = `Bearer ${window.localStorage.getItem("refreshToken")}`;
    }
    if (
      request.url.split("pl/")[0] &&
      requestsWithoutLoaderIcon.includes(request.url.split("pl/")[0])
    ) {
      return request;
    }
    if (document.getElementsByClassName("loader")[0]) {
      document
        .getElementsByClassName("loader")[0]
        .classList.add("visibleLoader");
    }
    requestCounter++;
    return request;
  },
);

instance.interceptors.response.use(
  (response) => {
    // Return a successful response back to the calling service
    decrementLoader();
    return response;
  },
  (error) => {
    // A cancelled request has no error.response: without this branch the code below threw a
    // TypeError and never decremented the counter, so the global loader spun forever.
    if (axios.isCancel(error)) {
      decrementLoader();
      return Promise.reject(error);
    }
    if (
      error.response &&
      error.response.status &&
      error.response.status === 403
    ) {
      Vue.notify({
        group: "error",
        text: "Nie posiadasz wymaganych uprawnień",
      });
      decrementLoader();
      // Bez reject wywołanie rozwiązywało się "sukcesem" (undefined) i akcje
      // pokazywały komunikaty typu "Pomyślnie zmieniono prowizję!" mimo błędu 403.
      return new Promise((resolve, reject) => {
        reject(error);
      });
    } else if (
      error.response &&
      error.response.data &&
      error.response.data.status &&
      error.response.data.status !== 401
    ) {
      decrementLoader();
      return new Promise((resolve, reject) => {
        reject(error);
      });
    } else if (error.response.data.status == 401) {
      decrementLoader();

      store.dispatch("logout");
    } else if (error.response.data.status == 401) {
      decrementLoader();

      store.dispatch("logout");
    } else {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  },
);

export default instance;
